import _JSON$stringify from 'babel-runtime/core-js/json/stringify';
import _typeof from 'babel-runtime/helpers/typeof';
import _Object$keys from 'babel-runtime/core-js/object/keys';
import axios from 'axios';
import adapter from 'axios/lib/adapters/http';
import convertRestriction from '../convertRestriction/index';
import convertToComponents from '../convertRestriction/convertToComponents';
import jsonp from '../jsonp';

import convertField from '../convertField';
var commodityUrl = 'https://common-buy.aliyun.com/buy/Operator/getCommodity.jsonp';
var anonymousCommodityUrl = 'https://cart.aliyun.com/commodity/getCommodity.json';

function isRds(commodityCode) {
  return ['rds', 'rds_intl'].includes(commodityCode);
}

export default function getConstraints(_ref) {
  var commodityCode = _ref.commodityCode,
      specCode = _ref.specCode,
      _ref$anonymous = _ref.anonymous,
      anonymous = _ref$anonymous === undefined ? true : _ref$anonymous;

  var isTest = process.env.DN_CMD == 'test';
  var productCode = 'commonbuy';
  var isUserInnerAccount = anonymous;

  if (isRds(commodityCode)) {
    productCode = 'rds';
  }
  if (!specCode) {
    specCode = commodityCode;
  }
  if (!commodityCode) {
    return null;
  }
  if (isTest || anonymous) {
    var options = {
      method: 'get',
      url: anonymousCommodityUrl,
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json'
      },
      params: {
        commodityCode: commodityCode,
        specCode: specCode,
        productCode: productCode,
        isUserInnerAccount: isUserInnerAccount
      }
    };
    if (isTest) {
      options.adapter = adapter;
    }
    return axios(options).then(function (response) {
      if (response.status >= 200 && response.status < 300) {
        if (response.data.code = '200') {
          if (productCode == 'rds') {
            return response.data.data;
          }
          var fields = convertField(response.data.data);
          return {
            components: convertToComponents(fields),
            constraints: convertRestriction({
              restrictInfos: response.data.data.restrictInfos,
              fields: fields
            })
          };
        }
      }
      var error = new Error(response.statusText);
      error.response = response;
      throw error;
    });
  }
  function stringify() {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return _Object$keys(obj).filter(function (k) {
      return obj[k] || +obj[k] === 0;
    }).map(function (k) {
      var value = obj[k];
      if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'object') {
        value = encodeURIComponent(_JSON$stringify(value));
      } else {
        value = encodeURIComponent(value);
      }
      return encodeURIComponent(k) + '=' + value;
    }).join('&');
  }

  return jsonp(commodityUrl, {
    param: stringify({
      commodityCode: commodityCode,
      specCode: specCode,
      orderType: 'buy'
    }) + '&callback'
  }).then(function (ret) {
    if (ret.code = '200') {
      return ret.data;
    }
  });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ali/common-cpq-constraint/es/commonbuy/getConstraints.js
// module id = 167
// module chunks = 0